import { getTeamLogoUrl } from "../getTeamLogoUrl";
export function buildEventName({ event, logos, staticS3Host, hasScoreboard, isSwooshTeamLogosEnabledForPrePacks, swooshBaseUrl, dict }) {
    if (logos.Teams && !hasScoreboard) {
        return {
            type: "LogoAndNames",
            name: eventNameMap.LogoAndNames(event, logos, staticS3Host, isSwooshTeamLogosEnabledForPrePacks, swooshBaseUrl, dict),
        };
    }
    return {
        type: "Name",
        name: eventNameMap.Event(event, dict)
    };
}
const eventNameMap = {
    Event: (event, dict) => {
        const participants = getParticipants(event);
        return {
            teamOne: {
                name: participants.teamOne.name,
            },
            teamTwo: {
                name: participants.teamTwo.name,
            },
            middleTerm: event.isTeamSwap ? dict.MiddleTermAt : dict.MiddleTermVs
        };
    },
    LogoAndNames: (event, logos, staticS3Host, isSwooshTeamLogosEnabledForPrePacks, swooshBaseUrl, dict) => {
        const participants = getParticipants(event);
        const teamOneLogo = getTeamLogoUrl({
            participant: participants.teamOne,
            logos,
            swooshBaseUrl,
            staticS3Host,
            isSwooshTeamLogosEnabledForPrePacks,
        });
        const teamTwoLogo = getTeamLogoUrl({
            participant: participants.teamTwo,
            logos,
            swooshBaseUrl,
            staticS3Host,
            isSwooshTeamLogosEnabledForPrePacks,
        });
        return {
            teamOne: {
                name: participants.teamOne.name,
                logo: teamOneLogo,
            },
            teamTwo: {
                name: participants.teamTwo.name,
                logo: teamTwoLogo,
            },
            middleTerm: event.isTeamSwap ? dict.MiddleTermAt : dict.MiddleTermVs
        };
    }
};
function getParticipants(event) {
    const home = event.participants.find(p => p.venueRole === "Home");
    const away = event.participants.find(p => p.venueRole === "Away");
    if (event.isTeamSwap) {
        return {
            teamOne: away,
            teamTwo: home
        };
    }
    return {
        teamOne: home,
        teamTwo: away
    };
}
//# sourceMappingURL=buildEventName.js.map